module.exports = __webpack_public_path__ + "img/tl.29cc3cde.jpg";